import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import viewbtn from "../Skills/images/iconoir_eye-solid.svg";
import { baseURL } from "../../config";

const DataTable = () => {
  const [posts, setPosts] = useState({ skills: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedSkill, setEditedSkill] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewSkill, setViewSkill] = useState(null);
  const [isManagerorHR, setIsManagerorHR] = useState(false);
  const id = localStorage.getItem("employeeid");
  const role = localStorage.getItem("userrole");
  const [showsubgoalEdit, setShowSubgoalEdit] = useState(false);
  const [showskillfilter, setShowSkillfilter] = useState(false);
  const [filterskill, setFilterSkill] = useState(null);
  const [isHR, setIsHR] = useState(false);
  const [filterassignee, setFilterassignee] = useState(null);
  const [options, setOptions] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [showassigneefilter, setShowAssigneefilter] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const userid = localStorage.getItem("employeeid");
  const [showdeptfilter, setShowDeptfilter] = useState(false);
  const [showcategoryfilter, setShowCategoryfilter] = useState(false);
  const [filterdepartment, setFilterdepartment] = useState(null);
  const [filtercategory, setFilterCategory] = useState(null);
  const [categoriesndata, setCategoriesData] = useState(null);

  useEffect(() => {
    if (role === "ROLE_HR") {
      setIsHR(role === "ROLE_HR");
      setShowDeptfilter(true);
      setShowCategoryfilter(true);
    }
    setIsManagerorHR(role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR");
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + userid
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);
        console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    //   alert(managerId);
    // if (managerId) {managerId
    fetchData();
    //}
  }, [userid]);
  useEffect(() => {
    const fetchPostList = async () => {
      try {
        let strSkillsURL = `${baseURL}/skills`;
        if (role === "ROLE_USER") {
          strSkillsURL = `${baseURL}/myskills?empid=` + id;
        }
        const { data } = await axios(strSkillsURL);
        console.log("Fetched data:", data);
        if (Array.isArray(data.skills)) {
          setPosts({ skills: data.skills });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
      if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
        setShowAssigneefilter(true);
        setShowSkillfilter(true);
      }
    };
    fetchPostList();
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${baseURL}/skills`);
        setOptions(response.data.skills);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  const handleChangeSkill = (event) => {
    let sid = event.target.value;
    setFilterSkill(sid);
    getAllSkillsforConditions(sid, filterassignee);
  };
  const handleChangdAssignee = (event) => {
    let assignee = event.target.value;
    setFilterassignee(assignee);
    getAllSkillsforConditions(filterskill, assignee);
    // getAllSmartgoalsforConditions(filterdepartment,filterenddate,assignee);
  };

  const handleChangeDepartment = (event) => {
    let did = event.target.value;
    setFilterdepartment(did);
    getAllSkillsforConditionsHR(did, filtercategory);
  };
  const handleChangeCategory = (event) => {
    let cid = event.target.value;
    setFilterCategory(cid);
    getAllSkillsforConditionsHR(filterdepartment, cid);
  };

  // const getAllSkillsforskillid = async (sid) => {
  //         try {
  //             const { data } = await axios("http://localhost:3050/getskillsbyidtofilter?sid="+sid);

  //                 setPosts([]);

  //                 //alert(sm);
  //                 setPosts({ skills: data.skills });
  //             //} else {
  //                 console.error("Data is not an array:", data);
  //           //  }
  //         } catch (error) {
  //             console.error("Error fetching posts:", error);
  //         }
  //     };
  const handleSaveEditedSkill = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/updateskill`,
        editedSkill
      );
      console.log("Updated Skill:", response.data);
      const updatedSkills = posts.skills.map((skill) => {
        if (skill.id === editedSkill.id) {
          return editedSkill;
        }
        return skill;
      });
      setPosts({ skills: updatedSkills });
      setShowEditModal(false);
    } catch (error) {
      console.error("Error updating Skill:", error);
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleEdit = (skill) => {
    setEditedSkill(skill);
    setShowEditModal(true);
  };

  const handleComment = (skill) => {
    setSelectedSkill(skill);
    setShowCommentModal(true);
  };

  const handleView = (skill) => {
    setViewSkill(skill);
    setShowViewModal(true);
  };

  const getProgressColor = (progress) => {
    if (progress <= 30) {
      return "danger";
    } else if (progress <= 60) {
      return "warning";
    } else {
      return "success";
    }
  };

  const getAllSkillsforConditionsHR = async (departmentid, categoryid) => {
    try {
      const { data } = await axios(
        `${baseURL}/skillswithfilterHR?departmentid=` +
          departmentid +
          "&categoryid=" +
          categoryid
      );

      setPosts([]);

      //alert(sm);
      setPosts({ skills: data.skills });
      //} else {
      console.error("Data is not an array:", data);
      //  }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const getAllSkillsforConditions = async (skillid, assignee) => {
    try {
      const { data } = await axios(
        `${baseURL}/skillswithfilter?assignee=` +
          assignee +
          "&skillname=" +
          skillid
      );

      setPosts([]);

      //alert(sm);
      setPosts({ skills: data.skills });
      //} else {
      console.error("Data is not an array:", data);
      //  }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleResetFilter = () => {
    setFilterSkill("");
    setFilterassignee("");
    setFilterCategory("");
    setFilterdepartment("");

    fetchAllSkills();
  };

  const fetchAllSkills = async () => {
    try {
      let strSkillsURL = `${baseURL}/skills`;
      if (role === "ROLE_USER") {
        strSkillsURL = `${baseURL}/myskills?empid=${id}`;
      }
      const { data } = await axios(strSkillsURL);
      console.log("Fetched data:", data);
      if (Array.isArray(data.skills)) {
        setPosts({ skills: data.skills });
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getdepartments`
        );
        setDepartments(response.data.departments);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getskillcategories`
        );
        setCategoriesData(response.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchOptions();
  }, []);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.skills.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <div className="col-lg-12 d-flex p-2 pb-2">
        {showskillfilter && (
          <div className="col-lg-4 d-flex">
            <select
              className="form-select form-control"
              name="skillnameval"
              value={filterskill}
              onChange={(e) => {
                handleChangeSkill(e);
              }}
            >
              <option>Select a Skill</option>
              {options.map((option) => (
                <option key={option.id} value={option.skillname}>
                  {option.skillname}
                </option>
              ))}
            </select>
          </div>
        )}

        {showassigneefilter && (
          <div className="col-lg-6 d-flex">
            <select
              className="w-75 ml-1 p-0"
              value={filterassignee}
              onChange={(e) => {
                handleChangdAssignee(e);
              }}
            >
              <option>Select Assignee</option>

              {teamMembers.map((option) => (
                <option key={option.id} value={option.employeeid}>
                  {option.FirstName} {option.LastName} -{option.employeeid}
                </option>
              ))}
            </select>
            <input
              className="bg-danger text-white pl-3 pr-3 border-0 rounded"
              type="reset"
              value="Reset Filter"
              onClick={() => handleResetFilter()}
            />
          </div>
        )}

        {showdeptfilter && (
          <div className="col-lg-5 d-flex">
            <select
              className="form-select form-control"
              name="departmentid"
              value={filterdepartment}
              onChange={(e) => {
                handleChangeDepartment(e);
              }}
            >
              <option>Select a Department</option>
              {departments.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.departmentname}
                </option>
              ))}
            </select>
          </div>
        )}

        {showcategoryfilter && (
          <div class="col-lg-5">
            <select
              className="form-select form-control"
              name="category"
              value={filtercategory}
              onChange={(e) => {
                handleChangeCategory(e);
              }}
            >
              <option selected>Selected Category</option>
              {categoriesndata &&
                categoriesndata.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.categoryname}
                  </option>
                ))}
            </select>
          </div>
        )}
        {isHR && (
          <input
            className="bg-danger text-white pl-3 pr-3 border-0 rounded"
            type="reset"
            value="Reset Filter"
            onClick={() => handleResetFilter()}
          />
        )}
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Created By</th>
            <th>Skill</th>
            <th>Skill Level</th>
            <th>Assignees</th>
            <th>Progress</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {posts.skills.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center">
                No data
              </td>
            </tr>
          ) : (
            ""
          )}
          {currentPosts.map((skill, index) => (
            <tr key={index}>
              <td>{skill.id}</td>
              <td>{skill.creator_name}</td>
              <td>{skill.skillname}</td>
              <td>{skill.skilllevel}</td>
              <td>{skill.assignees}</td>
              <td>
                <ProgressBar
                  variant={getProgressColor(skill.progress)}
                  now={skill.progress}
                />
              </td>

              <td>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(skill)}
                >
                  <img src={Editbtn} alt="Edit" />
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleView(skill)}
                >
                  <img src={viewbtn} alt="View" />
                </ReactBootstrap.Button>
                {skill.certifilepath ? (
                  <a
                    href={`${baseURL}/getcertifcate?filename=${skill.certifilepath}`}
                    download // Add the download attribute
                  >
                    Certificate
                  </a>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {showEditModal && editedSkill && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Edit Skill</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <div>
              <label>
                <b>Skill Name :</b>
              </label>
              <input
                className="border-0"
                type="text"
                value={editedSkill.skillname}
                onChange={(e) =>
                  setEditedSkill({ ...editedSkill, skillname: e.target.value })
                }
              />
            </div>

            <div>
              <label>
                <b>Justification :</b>
              </label>
              <input
                className="border-0"
                type="text"
                value={editedSkill.justification}
                onChange={(e) =>
                  setEditedSkill({
                    ...editedSkill,
                    justification: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Progress:</b>
              </label>
              <input
                className="border-0"
                type="text"
                value={editedSkill.progress}
                onChange={(e) =>
                  setEditedSkill({ ...editedSkill, progress: e.target.value })
                }
              />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedSkill}
            >
              Save Changes
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {showViewModal && viewSkill && (
        <ReactBootstrap.Modal
          show={showViewModal}
          onHide={handleCloseViewModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>View Skill</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <p>Title: {viewSkill.skillname}</p>
            <p>Skill Level: {viewSkill.skilllevel}</p>
            <p>Progress: {viewSkill.progress}</p>
            <p>Justification: {viewSkill.justification}</p>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseViewModal}
            >
              Close
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.skills.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index + 1}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default DataTable;
